import { computed, SetupContext, unref } from 'vue';
import { IMapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
import { useState } from 'vuex-composition-helpers';
import _ from 'underscore';

const filtersMappingStoreName = 'mapForFilters';

export default ({ emit }: SetupContext) => {
    const {
        isExclusive,
        products,
        warranted,
    } = useState<IMapForFiltersState>(filtersMappingStoreName, ['isExclusive', 'warranted', 'products']);

    const selectededFiltersText = computed(() => {
        let text = 'Доп. параметры';
        const numOfSelected = +unref(isExclusive) + +unref(warranted);
        if (numOfSelected) {
            text += `: ${numOfSelected}`;
        }
        return text;
    });

    const isExclusiveFilterShow = computed(() => unref(isExclusive) || !!_.find(unref(products), (product) => product.isExclusive));

    const isExclusiveChanged = (isExclusiveValue: boolean) => {
        emit('is-exclusive-filter-changed', isExclusiveValue);
    };
    const warrantedChanged = (warrantedValue: boolean) => {
        emit('warranted-filter-changed', warrantedValue);
    };

    return {
        selectededFiltersText,
        isExclusiveFilterShow,
        isExclusiveChanged,
        warrantedChanged,
        isExclusiveSelected: isExclusive,
        warrantedSelected: warranted,
    };
};